<template>
  <div class="calc_result_filter" v-if="!filterLoading">
    <v-row
      style="
        padding: 15px 5px 0px 5px;
        position: fixed;
        width: 100%;
        background-color: white;
        z-index: 99999;
        top: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.5);
      "
    >
      <v-col cols="6" style="display: flex; justify-content: center">
        <v-btn color="warning" @click="clearAllFilter">Сбросить</v-btn>
      </v-col>
      <v-col cols="6" style="display: flex; justify-content: center">
        <v-btn color="#217899" style="color: white" @click="showFunc"
          >Показать</v-btn
        >
      </v-col>
    </v-row>
    <v-list dense style="padding-top: 60px">
      <template>
        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Виды принципалов"
              @clear="(evt) => clearData(evt, principals)"
              :show="showPrincipals"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in principals"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, principals)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Установление лимита на Принципала"
              @clear="(evt) => clearData(evt, limits)"
              :show="showLimits"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in limits"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, limits)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Гарантия по форме заказчика"
              @clear="
                (evt) => {
                  setFloatFilterBoxPosition(evt);
                  garantZakaz = false;
                }
              "
              :show="garantZakaz"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-model="garantZakaz"
                label="Да"
                dense
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Срок существования клиента, мес."
              @clear="(evt) => clearData(evt, lifes)"
              :show="showLifes"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in lifes"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, lifes)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Опыт исполнения контрактов и/или договоров, шт."
              @clear="(evt) => clearData(evt, practices)"
              :show="showPractices"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in practices"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, practices)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Пакет документов для получения гарантии"
              @clear="(evt) => clearData(evt, packets)"
              :show="showPackets"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in packets"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, packets)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Промежуточная управленческая отчетность ф.1 и ф.2 при УСН"
              @clear="(evt) => clearData(evt, usns)"
              :show="showUsns"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in usns"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, usns)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="ЭДО с агентом"
              @clear="(evt) => clearData(evt, edos)"
              :show="showEdos"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-for="item in edos"
                :key="item.id"
                :label="item.name"
                :value="item.selected"
                @click="(evt) => setData(evt, item, edos)"
                class="check"
              />
            </div>
          </v-col>
        </v-row>

        <v-row v-if="!ab100">
          <v-col cols="12">
            <FilterLegend
              legend="Условия работы с агентами"
              @clear="clearFee"
              :show="what_fee !== null ? true : false"
            />
            <v-radio-group v-model="what_fee" class="radio">
              <v-radio
                v-for="item in radio"
                :ref="item.value"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
            </v-radio-group>
            <div v-if="what_fee === 'range'">
              <div class="checkbox_group">
                <v-checkbox
                  v-for="item in agentsFeeMinType"
                  :key="item.id"
                  :label="`до ${item.name}%`"
                  :value="item.selected"
                  @click="(evt) => setData(evt, item, agentsFeeMinType)"
                  class="check"
                />
              </div>
            </div>
            <!-- <div v-if="what_fee === 'netto'">
              <div class="checkbox_group">
                <v-checkbox
                  v-for="item in nettoFeeType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.selected"
                  @click="(evt) => setData(evt, item, nettoFeeType)"
                  class="check"
                />
              </div>
            </div> -->
          </v-col>
        </v-row>

        <v-row v-if="what_fee !== 'netto'">
          <v-col cols="12">
            <FilterLegend
              legend="Возможность согласовать повышенное АВ"
              @clear="
                (evt) => {
                  up_box = false;
                  setFloatFilterBoxPosition(evt);
                }
              "
              :show="up_box"
            />
            <div class="checkbox_group">
              <v-checkbox
                v-model="up_box"
                label="Да"
                dense
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Выплаты при превышении стандартного тарифа"
              @clear="clearAgentsUp"
              :show="
                agentsupMinType.filter((item) => item.selected).length
                  ? true
                  : false
              "
            />
            <div>
              <div class="checkbox_group">
                <v-checkbox
                  v-for="item in agentsupMinType"
                  :key="item.id"
                  :label="`от ${item.name}%`"
                  :value="item.selected"
                  @click="(evt) => setData(evt, item, agentsupMinType)"
                  class="check"
                />
              </div>
              <!-- <v-row>
                <v-col cols="6"
                  ><v-text-field
                    v-model="agentsupMin"
                    label="% от"
                    type="number"
                    step="0.01"
                    dense
                /></v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="agentsupMax"
                    label="% до"
                    type="number"
                    step="0.01"
                    dense
                  />
                </v-col>
              </v-row> -->

              <!-- <v-select
          v-model="agentsupMinType"
          :items="feeType"
          label="Единицы измерения"
          item-text="name"
          item-value="id"
          dense
        /> -->

              <!-- <v-select
          v-model="agentsupMaxType"
          :items="feeType"
          label="Единицы измерения"
          item-text="name"
          item-value="id"
          dense
        /> -->
            </div>
          </v-col>
        </v-row>
        <v-row
          ><v-col cols="12">
            <FilterLegend
              legend="Условия выплат агентам при снижении"
              @clear="clearDown"
              :show="down_bank || down_agent || down_bank_agent ? true : false"
            />
            <div>
              <v-checkbox
                dense
                v-model="down_bank"
                label="за счет Банка"
                class="check"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
              <v-checkbox
                dense
                v-model="down_agent"
                label="за счет Агента"
                class="check"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
              <v-checkbox
                dense
                v-model="down_bank_agent"
                label="За счет Банка и Агента"
                class="check"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
            </div> </v-col
        ></v-row>

        <!-- <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="min_tarif"
              label="Минимальный тариф"
              dense
              @click="(evt) => setFloatFilterBoxPosition(evt)"
            />
            <div v-if="min_tarif">
              <div class="checkbox_group">
                <v-checkbox
                  v-for="item in minFeeType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.selected"
                  @click="(evt) => setData(evt, item, minFeeType)"
                  class="check"
                />
              </div>
              <v-text-field
                v-model="minFee"
                label="Значение"
                type="number"
                step="0.01"
                dense
              />
            </div>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <FilterLegend
              legend="Выплаты АВ"
              @clear="clearEdo"
              :show="
                edo_sdelka ||
                edo_mounth ||
                edo_decada ||
                edo_week ||
                edo_personal
                  ? true
                  : false
              "
            />
            <div>
              <v-checkbox
                dense
                class="check"
                v-model="edo_sdelka"
                label="по сделке"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
              <v-checkbox
                dense
                class="check"
                v-model="edo_mounth"
                label="ежемесячно"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
              <v-checkbox
                dense
                class="check"
                v-model="edo_decada"
                label="по декадам"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
              <v-checkbox
                dense
                class="check"
                v-model="edo_week"
                label="еженедельно"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
              <v-checkbox
                dense
                class="check"
                v-model="edo_personal"
                label="индивидуально"
                @click="(evt) => setFloatFilterBoxPosition(evt)"
              />
            </div>
          </v-col>
        </v-row>
      </template>
    </v-list>
  </div>
  <div v-else style="display: flex; justify-content: center">
    <Loading color="#217899" />
  </div>
</template>
<script>
import calcConsts from "@/plugins/calcConsts";
import FilterLegend from "./FilterLegend.vue";
import Loading from "./loading.vue";
export default {
  name: "calc_result_filter",
  components: { FilterLegend, Loading },
  data: () => ({
    radio: calcConsts.radio,
    feeType: calcConsts.feeType,
    ab100: false,
  }),
  methods: {
    clearAllFilter(evt) {
      this.garantZakaz = false;
      this.up_box = false;
      this.min_tarif = false;
      this.clearFee(evt);
      this.clearAgentsUp(evt);
      this.clearDown(evt);
      this.clearEdo(evt);
      this.principals = this.clearSelected(this.principals);
      this.limits = this.clearSelected(this.limits);
      this.lifes = this.clearSelected(this.lifes);
      this.practices = this.clearSelected(this.practices);
      this.packets = this.clearSelected(this.packets);
      this.usns = this.clearSelected(this.usns);
      this.edos = this.clearSelected(this.edos);
      this.$store.commit("SET_SHOW_FILTRED", false);
      this.$store.commit("SET_FILTRED_PODHODIT_ITEMS", []);
    },
    clearSelected(arr) {
      return arr.map((item) => {
        item.selected = false;
        return item;
      });
    },
    setFloatFilterBoxPosition(evt) {
      if (evt.path[0] && evt.path[0].innerText !== "СБРОСИТЬ") {
        this.showFilterBox = true;
        this.filterBoxPosition.left = evt.clientX + 70;
        this.filterBoxPosition.top = evt.clientY - 55;
      }
      this.$store.dispatch("CALC_FILTER");
    },
    setData(evt, item, objData) {
      for (const row of objData) {
        if (item.id == row.id) {
          row.selected = !row.selected;
        }
      }
      this.setFloatFilterBoxPosition(evt);
    },
    clearData(evt, objData) {
      objData.map((item) => {
        item.selected = false;
      });
      this.setFloatFilterBoxPosition(evt);
    },
    showData(objData) {
      const find = objData.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    clearFee(evt) {
      this.what_fee = null;
      this.agentsFeeMinType = this.clearSelected(this.agentsFeeMinType);
      this.nettoFeeType = this.clearSelected(this.nettoFeeType);
      evt && this.setFloatFilterBoxPosition(evt);
    },
    clearAgentsUp(evt) {
      this.agentsupMinType = this.clearSelected(this.agentsupMinType);
      this.agentsupMin = "";
      this.agentsupMax = "";
      evt && this.setFloatFilterBoxPosition(evt);
    },
    clearDown(evt) {
      this.down_bank = false;
      this.down_agent = false;
      this.down_bank_agent = false;
      evt && this.setFloatFilterBoxPosition(evt);
    },
    clearEdo(evt) {
      this.edo_sdelka = false;
      this.edo_mounth = false;
      this.edo_decada = false;
      this.edo_week = false;
      this.edo_personal = false;
      evt && this.setFloatFilterBoxPosition(evt);
    },
  },

  computed: {
    filter: {
      get() {
        return this.$store.getters.filter;
      },
      set(val) {
        this.$store.dispatch("setFilter", val);
      },
    },
    filterLoading() {
      return this.$store.getters.getFilterLoading;
    },
    showPrincipals() {
      const find = this.principals.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    showLimits() {
      const find = this.limits.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    showLifes() {
      const find = this.lifes.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    showPractices() {
      const find = this.practices.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    showPackets() {
      const find = this.packets.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    showUsns() {
      const find = this.usns.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    showEdos() {
      const find = this.edos.filter((item) =>
        item.selected === true ? true : false
      );
      return find.length ? true : false;
    },
    product: {
      get() {
        return this.$store.getters.getProductData;
      },
    },
    showFilterBox: {
      get() {
        return this.$store.getters.getShowFilterBox;
      },
      set(val) {
        this.$store.commit("SET_SHOW_FILTER_BOX", val);
      },
    },
    filterBoxPosition: {
      get() {
        return this.$store.getters.getFilterBoxPosition;
      },
      set(val) {
        this.$store.commit("SET_FILTER_POSITION", val);
      },
    },
    count: {
      get() {
        return this.$store.getters.getFilterCount;
      },
      set(val) {
        this.$store.commit("SET_FILTER_COUNT", val);
      },
    },
    showFunc: {
      get() {
        return this.$store.getters.getFilterShowFunc;
      },
      set(val) {
        this.$store.commit("SET_SHOW_FUNC", val);
      },
    },
    limits: {
      get() {
        return this.$store.getters.get_limits;
      },
      set(val) {
        this.$store.commit("set_limits", val);
      },
    },
    principals: {
      get() {
        return this.$store.getters.get_principals;
      },
      set(val) {
        this.$store.commit("set_principals", val);
      },
    },
    lifes: {
      get() {
        return this.$store.getters.get_lifes;
      },
      set(val) {
        this.$store.commit("set_lifes", val);
      },
    },
    garantZakaz: {
      get() {
        return this.$store.getters.get_garantZakaz;
      },
      set(val) {
        this.$store.commit("set_garantZakaz", val);
      },
    },
    practices: {
      get() {
        return this.$store.getters.get_practices;
      },
      set(val) {
        this.$store.commit("set_practices", val);
      },
    },
    packets: {
      get() {
        return this.$store.getters.get_packets;
      },
      set(val) {
        this.$store.commit("set_packets", val);
      },
    },
    usns: {
      get() {
        return this.$store.getters.get_usns;
      },
      set(val) {
        this.$store.commit("set_usns", val);
      },
    },
    edos: {
      get() {
        return this.$store.getters.get_edos;
      },
      set(val) {
        this.$store.commit("set_edos", val);
      },
    },
    up_box: {
      get() {
        return this.$store.getters.get_up_box;
      },
      set(val) {
        this.$store.commit("set_up_box", val);
      },
    },
    what_fee: {
      get() {
        return this.$store.getters.get_what_fee;
      },
      set(val) {
        this.$store.commit("set_what_fee", val);
      },
    },
    agentsFeeMin: {
      get() {
        return this.$store.getters.get_agentsFeeMin;
      },
      set(val) {
        this.$store.commit("set_agentsFeeMin", val);
      },
    },
    agentsFeeMinType: {
      get() {
        return this.$store.getters.get_agentsFeeMinType;
      },
      set(val) {
        this.$store.commit("set_agentsFeeMinType", val);
      },
    },
    agentsFeeMax: {
      get() {
        return this.$store.getters.get_agentsFeeMax;
      },
      set(val) {
        this.$store.commit("set_agentsFeeMax", val);
      },
    },
    agentsFeeMaxType: {
      get() {
        return this.$store.getters.get_agentsFeeMaxType;
      },
      set(val) {
        this.$store.commit("set_agentsFeeMaxType", val);
      },
    },
    nettoFee: {
      get() {
        return this.$store.getters.get_nettoFee;
      },
      set(val) {
        this.$store.commit("set_nettoFee", val);
      },
    },
    nettoFeeType: {
      get() {
        return this.$store.getters.get_nettoFeeType;
      },
      set(val) {
        this.$store.commit("set_nettoFeeType", val);
      },
    },
    nettoFeeMax: {
      get() {
        return this.$store.getters.get_nettoFeeMax;
      },
      set(val) {
        this.$store.commit("set_nettoFeeMax", val);
      },
    },
    nettoFeeMaxType: {
      get() {
        return this.$store.getters.get_nettoFeeMaxType;
      },
      set(val) {
        this.$store.commit("set_nettoFeeMaxType", val);
      },
    },
    agentsupMin: {
      get() {
        return this.$store.getters.get_agentsupMin;
      },
      set(val) {
        this.$store.commit("set_agentsupMin", val);
      },
    },
    agentsupMinType: {
      get() {
        return this.$store.getters.get_agentsupMinType;
      },
      set(val) {
        this.$store.commit("set_agentsupMinType", val);
      },
    },
    agentsupMax: {
      get() {
        return this.$store.getters.get_agentsupMax;
      },
      set(val) {
        this.$store.commit("set_agentsupMax", val);
      },
    },
    agentsupMaxType: {
      get() {
        return this.$store.getters.get_agentsupMaxType;
      },
      set(val) {
        this.$store.commit("set_agentsupMaxType", val);
      },
    },
    down_bank: {
      get() {
        return this.$store.getters.get_down_bank;
      },
      set(val) {
        this.$store.commit("set_down_bank", val);
      },
    },
    down_agent: {
      get() {
        return this.$store.getters.get_down_agent;
      },
      set(val) {
        this.$store.commit("set_down_agent", val);
      },
    },
    down_bank_agent: {
      get() {
        return this.$store.getters.get_down_bank_agent;
      },
      set(val) {
        this.$store.commit("set_down_bank_agent", val);
      },
    },
    minFee: {
      get() {
        return this.$store.getters.get_minFee;
      },
      set(val) {
        this.$store.commit("set_minFee", val);
      },
    },
    min_tarif: {
      get() {
        return this.$store.getters.get_min_tarif;
      },
      set(val) {
        this.$store.commit("set_min_tarif", val);
      },
    },
    minFeeType: {
      get() {
        return this.$store.getters.get_minFeeType;
      },
      set(val) {
        this.$store.commit("set_minFeeType", val);
      },
    },
    edo_sdelka: {
      get() {
        return this.$store.getters.get_edo_sdelka;
      },
      set(val) {
        this.$store.commit("set_edo_sdelka", val);
      },
    },
    edo_mounth: {
      get() {
        return this.$store.getters.get_edo_mounth;
      },
      set(val) {
        this.$store.commit("set_edo_mounth", val);
      },
    },
    edo_decada: {
      get() {
        return this.$store.getters.get_edo_decada;
      },
      set(val) {
        this.$store.commit("set_edo_decada", val);
      },
    },
    edo_week: {
      get() {
        return this.$store.getters.get_edo_week;
      },
      set(val) {
        this.$store.commit("set_edo_week", val);
      },
    },
    edo_personal: {
      get() {
        return this.$store.getters.get_edo_personal;
      },
      set(val) {
        this.$store.commit("set_edo_personal", val);
      },
    },
    showFiltred: {
      get() {
        return this.$store.getters.getShowFiltred;
      },
    },
  },
  async created() {
    this.$store.commit("SET_FILTER_LOADING", true);

    this.clearAllFilter();
    try {
      // await this.$store.dispatch("addProductCS");
      this.principals = this.product.principals.map((item) => {
        item.selected = false;
        return item;
      });
      this.limits = this.product.limits.map((item) => {
        item.selected = false;
        return item;
      });
      this.lifes = this.product.lifes.map((item) => {
        item.selected = false;
        return item;
      });
      this.practices = this.product.practices.map((item) => {
        item.selected = false;
        return item;
      });
      this.packets = this.product.packets.map((item) => {
        item.selected = false;
        return item;
      });
      this.usns = this.product.usns.map((item) => {
        item.selected = false;
        return item;
      });
      this.edos = this.product.edos.map((item) => {
        item.selected = false;
        return item;
      });

      this.nettoFeeType = JSON.parse(JSON.stringify(this.feeType));
      this.minFeeType = JSON.parse(JSON.stringify(this.feeType));
    } finally {
      this.$store.commit("SET_FILTER_LOADING", false);
    }
  },
  mounted() {
    this.showFunc = async () => {
      const data = await this.$store.dispatch("CALC_FILTER");
      await this.$store.commit("SET_SHOW_FILTRED", true);

      if (!data.length) {
        await this.$store.commit("SET_FILTRED_PODHODIT_ITEMS", []);
        return;
      }
      await this.$store.commit("SET_FILTRED_PODHODIT_ITEMS", data);
    };
  },
  watch: {
    agentsupMinType: {
      handler: function (newArray) {
        for (const item of newArray.filter((item) => item.selected)) {
          if (item.name === "100") {
            this.ab100 = true;
            this.clearFee();
          }
          if (item.name !== "100") {
            this.ab100 = false;
          }
        }
        const find = newArray.find((item) => item.selected);
        if (!find) {
          this.ab100 = false;
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="sass">
.calc_result_filter
  padding: 10px
  .row + .row
    margin-top: 0px !important
  &__body
    height: calc(100vh - 120px)
    overflow: auto
  .check
    height: 24px !important
  .v-label
    color: rgba(0,0,0,.87) !important
    font-size: 0.9rem
    @media (max-width: 1380px)
      font-size: 0.7rem
  .v-messages
    height: 0 !important
    display: none !important
  .checkbox_group
    display: flex
    width: 100%
    flex-wrap: wrap
    column-gap: 10px
    .check
      height: fit-content !important
      margin-top: 0px
      .v-input__control
        .v-input__slot
          padding: 0px !important
          margin: 0px !important
        .v-messages
          height: 0 !important
          display: none !important
  .radio
    margin-top: 0
    .v-input__control
      .v-input__slot
        padding: 0px !important
        margin: 0px !important
      .v-messages
        height: 0 !important
        display: none !important
</style>
